import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

import ProducerList from "../Components/Producer/ProducerList";
import ProducerForm from "../Components/Producer/ProducerForm";

import Api from "../Services/Api";

function Producer() {
	let {producer} = useParams();
	let location = useLocation();

	const [displayDialog, setDisplayDialog] = useState(0);
	const [lastChildUpdate, setLastChildUpdate] = useState(null);

	const handleClose = () => {
		setDisplayDialog(0);
	};
	
	async function selectedItem(eventType, id) {
		if (eventType === "edit") {
			navigate(`edit/${id}`);
		}

		if (eventType === "create") {
			navigate("create");
		}

		if (eventType === "delete") {
			try {
				Api.del({endpoint: `producer/${id}`, contentType : 'application/json'})
					.then(response => {
						setDisplayDialog(1);
						setLastChildUpdate(Date.now());
					})
					.catch(error => {
						console.log(JSON.stringify(error));
						setDisplayDialog(-1);
					});
			} catch (error) {
				console.log(JSON.stringify(error));
				setDisplayDialog(-1);
			}
		}
	};

	let navigate = useNavigate();

	return (
		<>
		
			{producer && <ProducerForm producer={producer} />}
			{!producer && (
				<>
				{location.pathname.endsWith("/create") ? (
					<ProducerForm />
				) : (
					<ProducerList hook={selectedItem} lastUpdate={lastChildUpdate} />
				)}
				</>
			)}
			<Dialog
				open={displayDialog !== 0}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{displayDialog === 1 && "Operazione completata"}
					{displayDialog === -1 && "Errore"}
				</DialogTitle>
				<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{displayDialog === 1 && "Operazione completata con successo!"}
							{displayDialog === -1 && "Si è verificato un errore inatteso"}
						</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Chiudi</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

export default Producer;
